import React from 'react';
import QRGenerator from './QRGenerator';

export default function VcardQR() {
  return (
    <div className="flex flex-col gap-12 w-full max-w-4xl mx-auto font-sans">
      <section className="text-center max-w-2xl mx-auto flex flex-col gap-4 py-4">
        <span className="self-center px-3 py-1 rounded-full bg-indigo-600/10 text-indigo-400 border border-indigo-500/20 text-xs font-semibold uppercase tracking-wider">
          Digital Business Cards
        </span>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-tight bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
          Free Digital Business Card QR Maker
        </h1>
        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
          Create premium custom contact QR codes for your digital business cards. Share your name, phone, email, and company details instantly with one quick scan.
        </p>
      </section>

      <section className="w-full">
        <QRGenerator defaultTab="vcard" hideTabs={true} />
      </section>

      <section className="border-t border-gray-900 pt-10 flex flex-col gap-6 max-w-3xl mx-auto text-left">
        <div className="flex flex-col gap-3 bg-gray-900/20 border border-gray-900 rounded-2xl p-6">
          <h3 className="text-lg font-bold text-gray-200">How-To Steps:</h3>
          <ol className="flex flex-col gap-3 text-sm text-gray-400 list-decimal list-inside">
            <li>
              <strong className="text-gray-300">Enter Contact Details:</strong> Input your name, company title, number, email, and web links.
            </li>
            <li>
              <strong className="text-gray-300">Customize Style:</strong> Apply custom colors, gradients, rounded dots, and center brand logos.
            </li>
            <li>
              <strong className="text-gray-300">Download:</strong> Instantly download your print-ready high-resolution business card.
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-4 text-sm text-gray-400 leading-relaxed">
          <h2 className="text-lg font-bold text-gray-200">Modern Digital Networking</h2>
          <p>
            Handing out paper cards is slow and easy to lose. A digital contact QR card allows prospective clients, partners, and customers to save your complete contact details directly into their smartphone's native address book in seconds.
          </p>
          <p>
            Our client-side script compiles this structured information into a standard vCard string completely in your browser, keeping your personal contact details 100% private.
          </p>
        </div>
      </section>
    </div>
  );
}
